<script>
	import { createEventDispatcher } from 'svelte';
	import StockSearch from './components/StockSearch.svelte';

	const dispatch = createEventDispatcher();

	export let user;

	function doLogout() {
		user = undefined;
		dispatch('logout', {});
	}
</script>

<nav class="navbar navbar-light bg-tertiary">
	<a class="navbar-brand text-light" href="index.html">
		<h1><i class="fas fa-chart-line"></i> Borsalino</h1>
	</a>

	{#if user != null}
	<StockSearch/>

	<div class="text-right">
		Hello {user.firstName != null && user.firstName.length > 0 ? user.firstName : 'there'}!<br>
		<a href="." class="text-light" on:click|preventDefault="{doLogout}"><i class="fas fa-sign-out-alt"></i> Logout</a>
	</div>
	{/if}
</nav>
